import React from "react";
import { Dialog, DialogContent, Typography, Button, Box } from "@mui/material";
import SadFace from "../../assets/SadFace.png"; // adjust the import path

const CancelErrorModal = (props,activeOrder) => {
  console.log("status",props,activeOrder)
  return (
    <Dialog
      open={props?.cancleErrorflag}
      onClose={() => props.setCancleErrorflag(false)}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          width: "300px",
          position: "relative",
          overflow: "visible", // allows floating image
        },
      }}
    >
      {/* Floating Image */}
      <Box
        component="img"
        src={SadFace}
        alt="Sad Face"
        sx={{
          position: "absolute",
          top: "-40px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "80px",
          height: "80px",
        }}
      />

      <DialogContent
        sx={{
          pt: "50px",
          textAlign: "center",
          color: "#384F6F",
          fontFamily: "Roboto",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: "28px",
            letterSpacing: "0.5px",
            color: "#384F6F",
            mt: 2,
          }}
        >
          Order can’t be cancelled
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mt: 1.5,
            color: "rgba(56, 79, 111, 0.69)",
            fontSize: "12px",
            lineHeight: "15px",
          }}
        >
        {/*   {props?.cancleErrorMsg} */}

Due to some reasons your order can't be cancelled.

        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <Button
            variant="contained"
            onClick={(e) => props.setCancleErrorflag(false)}
            sx={{
              width: "70%",
              backgroundColor: "#00B177",
              color: "white",
              borderRadius: "10px",
              fontWeight: 600,
              textTransform: "none",
              "&:hover": { backgroundColor: "#2f415e" },
            }}
          >
            OK
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CancelErrorModal;
